import { useCoreStore } from '@/stores/coreStore'
import { useAutoRefresh } from '../useAutorefresh'
import type { ApiKeyType } from '@/services/api-keys-v2-service/types'
import type { Ref } from 'vue'

export const useCexPositionsRefresher = (cex: Ref<string>, keyType: ApiKeyType) => {
  const coreStore = useCoreStore()
  const positionsRefresher = useAutoRefresh(async () => {
    await updatePositions()
  }, 30000)

  const updatePositions = async (callback?: () => Promise<void>) => {
    const pActionId = `positions/${cex.value}`
    await coreStore.fetchAllPositions(pActionId, cex.value, keyType)
    if (callback) {
      await callback()
    }
  }

  return {
    positionsRefresher,
    updatePositions,
  }
}
